export const AccountsColumns = [
  {
    uid: "company_name",
    name: "Name",
    sortable: true,
    align: "left",
    width: "300px",
  },
  {
    uid: "company_size",
    name: "Company Size",
    sortable: true,
    align: "left",
    width: "200px",
  },
  {
    uid: "revenue",
    name: "Revenue",
    sortable: true,
    align: "left",
    width: "200px",
  },
  {
    uid: "location",
    name: "Location",
    sortable: true,
    align: "left",
    width: "200px",
  },
  {
    uid: "status",
    name: "Status",
    sortable: true,
    align: "left",
    width: "150px",
  },
  {
    uid: "actions",
    name: "Actions",
    align: "center",
    sortable: false,
    width: "80px",
  },
];

export const AccountsTabs = [
  { key: "dashboard", title: "Dashboard" },
  { key: "account360", title: "Account 360" },
  { key: "accountPlan", title: "Account Plan" },
  {key:"whitespaceAudit", title: "Whitespace Audit" },
  { key: "relationship", title: "Relationship" },
  { key: "conversations", title: "Conversations" },
  { key: "deals", title: "Deals" },
];

export const AccountActionPlanStatusOptions = [
  { key: "in-progress", label: "In Progress", dotColor: "orange" },
  { key: "pending", label: "Pending", dotColor: "red" },
  { key: "completed", label: "Completed", dotColor: "green" },
];

export const getAccountPlanStatusDotClass = (dotColor) => {
  const colorMap = {
    orange: "bg-orange-500",
    red: "bg-red-500",
    green: "bg-green-500",
  };

  return colorMap[dotColor] || "bg-gray-400";
};
